import {
  CreateObjectRequest,
  FieldValueDto,
  ObjectDto,
  ObjectWithFieldsDto,
  UpdateObjectRequest,
} from "../../api-client";
import { ObjectState } from "../states/ConstructorPageStates/ObjectState";
import { ObjectValue } from "../states/ConstructorPageStates/ObjectValue";
import { UniqueId } from "../UniqueId";
import { Status } from "../enums/Status";
import { PropertyState } from "../states/ConstructorPageStates/PropertyState";
import { PropertyType } from "../enums/PropertyType";
import { DEFAULT_OBJECT_IMAGE } from "../constants/constants";
import { GameObjectState } from "../states/GamePageStates/GameObjectState";

export class ObjectMapper {
  public static toFieldValue(
    objectValue: ObjectValue,
    propertyApiId: string
  ): FieldValueDto {
    return {
      fieldId: propertyApiId,
      value: objectValue.value.toString(),
    };
  }

  public static toCreateObjectRequest(
    object: ObjectState,
    propertyApiIds: string[]
  ): CreateObjectRequest {
    return {
      name: object.name,
      thumbnail: object.image,
      fieldValues: this.toFieldValues(
        Object.values(object.properties),
        propertyApiIds
      ),
    };
  }

  public static toUpdateObjectRequest(
    object: ObjectState,
    propertyApiIds: string[]
  ): UpdateObjectRequest {
    return {
      newName: object.name,
      newThumbnail: object.image,
      newFieldValues: this.toFieldValues(
        Object.values(object.properties),
        propertyApiIds
      ),
    };
  }

  public static toFieldValues(
    objectValues: ObjectValue[],
    propertyApiIds: string[]
  ): FieldValueDto[] {
    return objectValues.map((objectValue, index) => {
      return {
        fieldId: propertyApiIds[index],
        value: objectValue.value.toString(),
      };
    });
  }

  public static toCreateObjectRequests(
    objects: ObjectState[],
    propertyApiIds: string[]
  ): CreateObjectRequest[] {
    return objects.map((object) => {
      return {
        name: object.name,
        thumbnail: object.image,
        fieldValues: this.toFieldValues(
          Object.values(object.properties),
          propertyApiIds
        ),
      };
    });
  }

  public static toUpdateObjectRequests(
    objects: ObjectState[],
    propertyApiIds: string[]
  ): UpdateObjectRequest[] {
    return objects.map((object) => {
      return {
        newName: object.name,
        newThumbnail: object.image,
        newFieldValues: this.toFieldValues(
          Object.values(object.properties),
          propertyApiIds
        ),
      };
    });
  }

  public static toObjectValueProperties(
    fieldValues: { [key: string]: any },
    propertyStates: PropertyState[]
  ): { [propertyId: number]: ObjectValue } {
    return propertyStates.reduce((acc, property) => {
      if (property.apiId) {
        switch (property.type) {
          case PropertyType.Integer:
            acc[property.id] = {
              type: property.type,
              value: fieldValues[property.apiId] as number,
            };
            break;
          case PropertyType.Date:
          case PropertyType.Image:
          case PropertyType.String:
            acc[property.id] = {
              type: property.type,
              value: fieldValues[property.apiId] as string,
            };
            break;
        }
      }

      return acc;
    }, {} as { [propertyId: number]: ObjectValue });
  }

  public static toObjectState(
    objectWithFieldsDto: ObjectWithFieldsDto,
    propertyStates: PropertyState[],
    objectId?: number
  ): ObjectState {
    return {
      id: objectId ? objectId : UniqueId.generateUniqueId(),
      apiId: objectWithFieldsDto.id ? objectWithFieldsDto.id : null,
      name: objectWithFieldsDto.name ? objectWithFieldsDto.name : "Объект",
      status: Status.None,
      image: objectWithFieldsDto.thumbnail
        ? objectWithFieldsDto.thumbnail
        : DEFAULT_OBJECT_IMAGE,
      properties: objectWithFieldsDto.fieldValues
        ? this.toObjectValueProperties(
            objectWithFieldsDto.fieldValues,
            propertyStates
          )
        : {},
    };
  }

  public static toObjectStates(
    objectWithFieldsDtos: ObjectWithFieldsDto[],
    propertyStates: PropertyState[]
  ): ObjectState[] {
    return objectWithFieldsDtos.map((objectWithFieldsDto) => {
      return {
        id: UniqueId.generateUniqueId(),
        apiId: objectWithFieldsDto.id ? objectWithFieldsDto.id : null,
        name: objectWithFieldsDto.name ? objectWithFieldsDto.name : "Объект",
        status: Status.None,
        image: objectWithFieldsDto.thumbnail
          ? objectWithFieldsDto.thumbnail
          : DEFAULT_OBJECT_IMAGE,
        properties: objectWithFieldsDto.fieldValues
          ? this.toObjectValueProperties(
              objectWithFieldsDto.fieldValues,
              propertyStates
            )
          : {},
      };
    });
  }
}
